import { tx } from "@/i18n/tx";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// Controlled confirm dialog: shown when `open` is truthy.
export default function DuplicateDialog({ open, title, description, confirmLabel = tx("ui_duplicatedialog.kb77b4d"), cancelLabel = tx("ui_duplicatedialog.kd12c3b"), onConfirm, onCancel, testId = "duplicate-dialog" }) {
  return (
    <AlertDialog open={!!open} onOpenChange={(v) => { if (!v) onCancel(); }}>
      <AlertDialogContent className="max-w-[92vw] sm:max-w-md rounded-2xl z-[80]" data-testid={testId}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription asChild><div className="text-sm text-text-secondary space-y-1">{description}</div></AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel} data-testid={`${testId}-cancel`}>{cancelLabel}</AlertDialogCancel>
          {confirmLabel && <AlertDialogAction onClick={onConfirm} data-testid={`${testId}-confirm`}>{confirmLabel}</AlertDialogAction>}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
